import { createFileRoute } from '@tanstack/react-router';

import { VoiceChatParticipationStep } from '@/features/onboarding/components/steps/lf/voiceChatParticipationStep';

export const Route = createFileRoute(
  '/_protected/onboarding/_steps/voice-chat-participation',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <VoiceChatParticipationStep />;
}
